module.exports = __webpack_public_path__ + "static/media/email-new-button.36dee232.svg";